<template>
  <div class="person-project">
    <div class="person-project-title">{{ $t('personProject.title') }}</div>
    <div class="table-center">
      <el-row class="filter-row">
        <el-col :span="4" v-if="showField('realNameChJson') || showField('realNameEnJson')">
          <el-input v-model="params.keyword" :placeholder="$t('common.pleaseInputKeyword')" style="width: 90%"></el-input>
        </el-col>
        <el-col :span="4" v-if="showField('genderJson')">
          <el-select v-model="params.gender" :placeholder="$t('common.pleaseSelect') + ' ' + $t('common.gender')" style="width: 90%" clearable filterable>
            <el-option v-for="item in genderList" :key="item.id" :label="item.nameCh" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-if="showField('groupJson')">
          <el-select v-model="params.groupId" :placeholder="$t('common.pleaseSelect') + ' ' + $t('common.group')" style="width: 90%" clearable filterable>
            <el-option v-for="item in groupList" :key="item.id" :label="localeValue(item, groupNameKey)" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="findAthleteList">{{ $t('common.search') }}</el-button>
          <el-button @click="emptyParams">{{ $t('common.reset') }}</el-button>
        </el-col>
      </el-row>
      <div class="table-body">
        <el-table :data="athleteList" :border="true" height="100%">
        <el-table-column type="index" :label="$t('common.serialNo')" width="50" :fixed="true"></el-table-column>
        <el-table-column prop="realNameCh" :label="labelField('realNameChJson')" min-width="150" :fixed="true" v-if="showField('realNameChJson')"></el-table-column>
        <el-table-column prop="realNameEn" :label="$t('athleteInfo.realNameEn')" min-width="150" :fixed="true" v-if="showField('realNameEnJson')"></el-table-column>
        <el-table-column prop="birthday" :label="$t('common.birthDate')" min-width="150" v-if="showField('birthdayJson')"></el-table-column>
        <el-table-column prop="age" :label="$t('common.age')" min-width="150" v-if="showField('ageJson')"></el-table-column>
        <el-table-column prop="gender" :label="$t('common.gender')" min-width="150" v-if="showField('genderJson')">
          <template slot-scope="scope">
            {{scope.row.gender === 1 ? $t('common.male') : $t('common.female')}}
          </template>
        </el-table-column>
        <el-table-column prop="groupNameCh" :label="$t('common.group')" min-width="150" v-if="showField('groupJson')">
          <template slot-scope="scope">
            {{localeValue(scope.row, competitionGroupNameKey)}}
          </template>
        </el-table-column>
        <el-table-column prop="personProjectList" :label="$t('common.project')" min-width="300">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.personProjectList" :key="item.id" style="width: 100%">
              <span v-if="index === 0">{{localeValue(item, competitionProjectNameKey)}}</span>
              <span v-else>、{{localeValue(item, competitionProjectNameKey)}}</span>
              <span v-if="item.description">（{{ remarkLabel }}：{{item.description}}）</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('common.operation')" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEditProject(scope.row.id, scope.row.groupId)" type="text" :disabled="isTeamSubmitted">{{ $t('personProject.editProject') }}</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>

    <!--  编辑报项  -->
    <el-dialog :title="$t('personProject.editProject')" :visible.sync="projectFormVisible" width="700px"
               lock-scroll :close-on-click-modal="false">
      <el-form ref="projectDataForm" :model="projectDataForm" :rules="projectRuleForm" v-loading="projectFormLoading" label-width="200px">
        <el-form-item :label="$t('common.project')" prop="projectCheck">
          <el-checkbox-group v-model="projectDataForm.projectCheck">
            <div class="project-checked" v-for="item in projectList" :key="item.id">
              <el-checkbox :label="item.id">{{localeValue(item, projectNameKey)}}</el-checkbox>
              <div v-if="projectDataForm.projectCheck.indexOf(item.id) !== -1 && item.isRemark === 1" class="project-remark">
                <el-input v-model="item.description" type="textarea" :placeholder="remarkPlaceholder"/>
              </div>
            </div>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="projectFormVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="projectBtnLoading" @click="handleEditProjectSubmit()">{{ $t('common.ok') }}</el-button>
    </span>
    </el-dialog>
  </div>
</template>
<script>
import {getAthleteListPersonProject} from "@/api/athlete";
import {listByAthleteId, savePersonProject} from "@/api/athleteProject";
import {listPersonProject} from "@/api/competitionProject";
import {getCompetitionGroupList} from "@/api/competitionGroup";
export default {
  name: "person-project",
  props: {
    teamInfo: {
      type: Object,
      required: true
    },
    competitionFormConfigInfo: {
      type: Object,
      default: function () {
        return {
          id: '',
          competitionId: '',
          teamForm: {},
          athleteForm: {},
          personForm: {},
          summaryForm: {}
        }
      }
    }
  },
  computed: {
    // 备注标题（报项表单配置，留空默认备注）
    remarkLabel() {
      const remarkLabel = (this.competitionFormConfigInfo.projectForm || {}).remarkLabel;
      return remarkLabel || this.$t('common.comment');
    },
    // 备注输入提示
    remarkPlaceholder() {
      return this.$t('common.pleaseInput') + this.remarkLabel;
    },
    // 是否显示字段
    showField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.athleteForm[fieldName];
        return fieldConfig && fieldConfig.isShow === 1;
      };
    },
    // 字段标签
    labelField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.athleteForm[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 组别名称中英文
    groupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事组别名称中英文
    competitionGroupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'groupNameCh' : 'groupNameEn';
    },
    // 项目名称中英文
    projectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事项目名称中英文
    competitionProjectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'projectNameCh' : 'projectNameEn';
    },
  },
  data() {
    return {
      // 运动员列表
      athleteList: [],
      // 查询条件
      params: {
        competitionId: '',
        realNameCh: '',
        gender: '',
        groupId: '',
        certificateNumber: '',
        keyword: ''
      },
      // 编辑报项表单
      projectFormVisible: false,
      // 编辑报项表单加载loading
      projectFormLoading: false,
      // 编辑报项表单确定loading
      projectBtnLoading: false,
      // 编辑项目表单
      projectDataForm: {
        projectCheck: []
      },
      // 项目列表
      projectList: [],
      // 性别
      genderList: [
        {id: 1, nameCh: this.$t('common.male')},
        {id: 2, nameCh: this.$t('common.female')},
      ],
      // 组别列表
      groupList: [],
      projectRuleForm: {
        projectCheck: [
          {required: true, message: this.$t('validate.requiredSelect'), trigger: 'blur'},
        ],
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.params.competitionId = id;
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.params.competitionId });
    } else {
      this.findAthleteList();
      this.findCompetitionGroupList();
    }
  },
  destroyed() {},
  methods: {
    // 运动员列表
    findAthleteList(){
      getAthleteListPersonProject(this.params).then((res) => {
        if (res.code === 200) {
          this.athleteList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 组别列表
    findCompetitionGroupList(){
      getCompetitionGroupList({competitionId: this.params.competitionId}).then((res) => {
        if (res.code === 200) {
          this.groupList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 项目列表
    findProjectList(groupId){
      let params = {
        competitionId: this.params.competitionId,
        projectType: 1,
        competitionGroupId: groupId
      }
      return listPersonProject(params).then((res) => {
        if (res.code === 200) {
          let projectList = res.data.list;
          let newProjectList = [];
          for (let i = 0; i < projectList.length; i++) {
            projectList[i].description = '';
            newProjectList.push(projectList[i]);
          }
          this.projectList = newProjectList;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 编辑报项表单
    handleEditProject(id, groupId){
      this.projectDataForm.athleteId = id || '';
      this.projectFormVisible = true;
      this.findProjectList(groupId).then(() => {
        this.$nextTick(() => {
          this.$refs['projectDataForm'].resetFields();
          if (id) {
            let params = {
              competitionId: this.params.competitionId,
              athleteId: id,
              projectType: 1
            }
            listByAthleteId(params).then((res) => {
              if (res.code === 200) {
                let personProjectList = res.data.list;
                this.projectDataForm.projectCheck = personProjectList.map(item => item.projectId);
                for (let i = 0; i < this.projectList.length; i++) {
                  let projectObj = this.projectList[i];
                  let regProjectObj = personProjectList.find(item => item.projectId === projectObj.id);
                  projectObj.description = regProjectObj ? (regProjectObj.description || '') : '';
                }
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.projectDataForm.competitionId = this.params.competitionId;
          }
        })
      });
    },
    // 根据项目ID获取项目列表中某个对象
    getProjectById(id){
      return this.projectList.find(item => item.id === id);
    },
    // 编辑报项提交
    handleEditProjectSubmit(){
      // 要求备注的项目必须填写
      let checkList = this.projectDataForm.projectCheck;
      for (let i = 0; i < checkList.length; i++) {
        let projectObj = this.getProjectById(checkList[i]);
        if (projectObj && projectObj.isRemark === 1 && !projectObj.description) {
          return this.$message.warning(this.remarkPlaceholder);
        }
      }
      this.$refs['projectDataForm'].validate((valid) => {
        if (valid) {
          let projectDataForm = this.projectDataForm;
          let projectCheck = projectDataForm.projectCheck;
          let personProjectList = [];
          for (let i = 0; i < projectCheck.length; i++) {
            let projectObj = this.getProjectById(projectCheck[i]);
            personProjectList.push({
              projectId: projectCheck[i],
              sortCode: projectObj.sortCode,
              description: projectObj.description
            })
          }
          let dataForm = {
            teamId: this.teamInfo.id,
            athleteId: projectDataForm.athleteId,
            personProjectList: personProjectList
          }
          this.projectBtnLoading = true;
          savePersonProject(this.params.competitionId, dataForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              this.findAthleteList();
              this.projectBtnLoading = false;
              this.projectFormVisible = false;
            } else {
              this.$message.error(res.msg);
              this.projectBtnLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    emptyParams() {
      this.params.realNameCh =  '';
      this.params.gender = '';
      this.params.groupId = '';
      this.params.certificateNumber = '';
      this.params.keyword = '';
      this.findAthleteList();
    }
  },
};
</script>
<style scoped lang="scss">
.person-project{
  width: 100%;

  .person-project-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    margin-bottom: 20px;
    border-bottom: 2px solid #1E50AE;
  }

  .table-center {
    height: calc(100vh - 300px);
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    .filter-row {
      flex-shrink: 0;
      margin-bottom: 10px;
    }

    .table-body {
      flex: 1;
      height: 0;
      min-height: 0;
      overflow: hidden;

      ::v-deep .el-table {
        height: 100%;
      }
    }
  }

  ::v-deep .el-table th {
    background-color: #f0f2f5;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  ::v-deep .el-table .el-table__row:hover > td {
    background-color: #ecf5ff;
  }

  .project-checked {
    margin-bottom: 4px;
  }

  .project-remark {
    margin: 6px 0 8px 24px;
    width: calc(100% - 24px);
  }
}
</style>
